import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { FaqComponent } from './features/faq/faq.component';
import { RegistrationComponent } from './features/registration/registration.component';
import { RegularyDataComponent } from './features/regulary-data/regulary-data.component';
import { EditProfileComponent } from './features/edit-profile/edit-profile.component';
import { SubscriptionsComponent } from './features/subscriptions/subscriptions.component';
import { InvoicesComponent } from './features/invoices/invoices.component';
import { AdministrationComponent } from './features/administration/administration.component';
import { PaymentComponent } from './features/payment/payment.component';
import { PaymentResponseComponent } from './features/paymentResponse/paymentResponse.component';
import { authGuard } from './core/guards/auth.guard';
import { unauthGuard } from './core/guards/unauth.guard';
import { accessGuard } from './core/guards/access.guard';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'offers', loadChildren: () => import('./features/offers/offers.module').then(m => m.OffersModule) },
  { path: 'faq', component: FaqComponent },
  { path: 'registration', component: RegistrationComponent, canActivate: [unauthGuard] },
  { path: 'regulatory-data', component: RegularyDataComponent },
  { path: 'edit-profile', component: EditProfileComponent, canActivate: [authGuard], canMatch: [accessGuard] },
  { path: 'subscriptions', component: SubscriptionsComponent, canActivate: [authGuard] },
  { path: 'invoices', component: InvoicesComponent, canActivate: [authGuard], canMatch: [accessGuard] },
  { path: 'administration', component: AdministrationComponent, canActivate: [authGuard] },
  { path: 'payment', component: PaymentComponent, canActivate: [authGuard], canMatch: [accessGuard] },
  { path: 'paymentResponse', component: PaymentResponseComponent, canActivate: [authGuard], canMatch: [accessGuard] },
  { path: 'contact', loadChildren: () => import('./features/contact/contact.module').then(m => m.ContactModule) },
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    preloadingStrategy: PreloadAllModules, // Preload lazy-loaded modules for better performance
  })],
  exports: [RouterModule]
})

export class AppRoutingModule { }